<template>
  <div>
    <v-card>
      <template v-if="$mode !== 'ecics'">
        <v-divider></v-divider>
        <v-card-title>
          <div class="body-2">{{labels.clmInfo}}</div>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{labels.exClm}}</v-subheader>
                <div>{{globalMotorForm.exClm ? 'Yes' : 'No'}}</div>
              </v-flex>
              <v-flex xs6>
              </v-flex>
              <v-flex xs6 v-if="globalMotorForm.exClm">
                <v-subheader class="queryLabel">{{labels.noClm}}</v-subheader>
                <div>{{globalMotorForm.noClm}}</div>
              </v-flex>
              <v-flex xs6 v-if="globalMotorForm.exClm">
                <v-subheader class="queryLabel">{{labels.clmAmt}}</v-subheader>
                <div>{{$store.state.agency.quotation.commonInfo.currPrefix}}{{formatDisplayNumber(globalMotorForm.clmAmt)}}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </template>
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.existingPolInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-subheader class="queryLabel">{{labels.ncdRate}}</v-subheader>
              <div>{{globalMotorForm.ncdPct}}%</div>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.exInsurer" :label="labels.exInsurer" :error-messages="errors.collect('exInsurer')" data-vv-name="exInsurer" :data-vv-as="labels.exInsurer" v-validate="'name|max:60'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.exPolNo" :label="labels.exPolNo" :error-messages="errors.collect('exPolNo')" data-vv-name="exPolNo" :data-vv-as="labels.exPolNo" v-validate="'entry|max:30'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="motorForm.exPolNoExp" :label="labels.exPolNoExp" :data-vv-as="labels.exPolNoExp" data-vv-name="exPolNoExp" :error-messages="errors.collect('exPolNoExp')"></cal-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="pt-3">
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, PROPOSAL_MOTOR_GENERAL } from '@/store/types'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import MessageMixin from '@/mixins/message'
import { formatDisplayNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        quoteInfo: 'Quotation Information',
        product: 'Product',
        busCls: 'Business Class',
        tariff: 'Tariff',
        cover: 'Type of Cover',
        exClm: 'Claims in Past 3 Years?',
        noClm: 'No. of Claims',
        clmAmt: 'Total Claim Amount',
        ncdRate: 'Existing NCD',
        startDate: 'Start Date',
        endDate: 'End Date',
        exInsurer: 'Existing Insurer',
        exPolNo: 'Existing Policy No.',
        exPolNoExp: 'Existing Policy No. Expiry',
        clmInfo: 'Claims Information',
        existingPolInfo: 'Existing Policy Information'
      },
      motorForm: {
        exInsurer: undefined,
        exPolNo: undefined,
        exPolNoExp: undefined
      }
    }
  },
  computed: {
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    globalMotorForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.motorForm.exInsurer = this.globalMotorForm.exInsurer
      this.motorForm.exPolNo = this.globalMotorForm.exPolNo
      this.motorForm.exPolNoExp = this.globalMotorForm.exPolNoExp
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(PROPOSAL_MOTOR_GENERAL, this.motorForm)
          this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
          this.$router.push({ name: 'motorProposalDriver' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      try {
        this.$store.commit(PROPOSAL_MOTOR_GENERAL, this.motorForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 1) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
    }
    this.doInit()
  },
  components: {
  },
  mixins: [
    SaveQuoteMixin,
    MessageMixin
  ]
}
</script>

<style>

</style>
